export default {
  namespaced: true,
  state: () => ({
    wsConnected: false,
    list: [],
  }),
  mutations: {
    SET_LIST(state, payload) {
      state.list = payload;
    },
    SOCKET_RECONNECT (state) {
      state.wsConnected = true;
    },
    SOCKET_ONOPEN (state) {
      state.wsConnected = true;
    },
    SOCKET_ONCLOSE (state) {
      state.wsConnected = false;
    },
    SOCKET_ONMESSAGE (state, records) {
      state.list.forEach((cryptoCurrency) => {
        const newPriceData = records[cryptoCurrency.assetCode] || false;
        if (!newPriceData) {
          return;
        }
        cryptoCurrency.changePercent24h = newPriceData.chg24h || cryptoCurrency.changePercent24h;
        cryptoCurrency.price = newPriceData.price || cryptoCurrency.price;
      });
    },
    SOCKET_ONERROR (state, event) {
      console.error(event);
    },
  },
  actions: {
    updateList ({ commit }, list) {
      commit('SET_LIST', list);
    },
  },
  getters: {
    list: (state) => state.list,
  },
};
